import { createContext } from 'react';

import { Result, ResultContextType } from '../types';

const ResultContext = createContext<ResultContextType>({
  result: {
    echteLeeftijd: 0,
    inputLeeftijd: 0,
    surveyId: 0,
    responseCode: '',
    topImprovements: [],
    topCompliments: [],
    answers: [],
  },
  updateResult: (result: Result) => {
    throw new Error(`setResult has not yet been implemented, result: ${JSON.stringify(result)}`);
  },
  updateInitialResult: (result: Result) => {
    throw new Error(`setResult has not yet been implemented, result: ${JSON.stringify(result)}`);
  },
  isModified: false,
  updateIsModified: (value: boolean) => {
    throw new Error(`updateIsModified has not yet been implemented, value: ${JSON.stringify(value)}`);
  },
  lockedAge: 0,
  lockedCategories: {
    improvements: [],
    compliments: [],
  },
  lockCategories: (type: 'improvements' | 'compliments', categories: string[]) => {
    throw new Error(
      `lockCategories has not yet been implemented, type: ${type}, categories: ${JSON.stringify(categories)}`
    );
  },
  resetResults: () => {
    throw new Error('resetResult has not yet been implemented');
  },
});

export default ResultContext;
